import { render, staticRenderFns } from "./EditExpenseForm.vue?vue&type=template&id=4ec3b92a&scoped=true"
import script from "./EditExpenseForm.vue?vue&type=script&lang=ts"
export * from "./EditExpenseForm.vue?vue&type=script&lang=ts"
import style0 from "./EditExpenseForm.vue?vue&type=style&index=0&id=4ec3b92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3b92a",
  null
  
)

export default component.exports